import { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { INTAKE_FONT } from "../../theme/intakeTokens";

export default function IntakeSuccessToast({
  open,
  message,
  type = "success",
  onClose,
  autoHideMs = 5000,
  left = 88,
}) {
  useEffect(() => {
    if (!open || !autoHideMs) return undefined;
    const timer = setTimeout(() => onClose?.(), autoHideMs);
    return () => clearTimeout(timer);
  }, [open, message, autoHideMs, onClose]);

  if (!open || !message) return null;

  const isCancelOrInfo = type === "cancel" || type === "info";
  const isWarning = type === "warning";
  const iconColor = isCancelOrInfo ? "#9CA3AF" : isWarning ? "#F59E0B" : "#1FAC6E";
  const iconSymbol = type === "cancel" ? "✕" : type === "info" ? "ℹ" : "✓";

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 24,
        left,
        zIndex: 1600,
        bgcolor: "#1A1A1A",
        color: "#FFFFFF",
        borderRadius: "8px",
        px: 2,
        py: 1.5,
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        boxShadow: "0 8px 24px rgba(0,0,0,0.28)",
        minWidth: 300,
        maxWidth: 420,
        fontFamily: INTAKE_FONT,
      }}
    >
      <Box
        sx={{
          width: 22,
          height: 22,
          borderRadius: "50%",
          border: `2px solid ${iconColor}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <Box
          component="span"
          sx={{
            color: iconColor,
            fontSize: 12,
            fontWeight: 700,
            lineHeight: 1,
            mt: "-1px",
          }}
        >
          {iconSymbol}
        </Box>
      </Box>
      <Typography sx={{ flex: 1, fontSize: 14, fontWeight: 500, lineHeight: 1.4 }}>
        {message}
      </Typography>
      <Box
        component="button"
        type="button"
        onClick={onClose}
        aria-label="Dismiss"
        sx={{
          border: "none",
          bgcolor: "transparent",
          color: "#FFFFFF",
          p: 0.25,
          m: 0,
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          opacity: 0.85,
          "&:hover": { opacity: 1 },
        }}
      >
        <CloseIcon sx={{ fontSize: 18 }} />
      </Box>
    </Box>
  );
}
